<div class="modal__content">
    <div class="saving-popup-header">
        <span>Saving...</span>
    </div>
    <div class="saving-popup-text">
        <div class="loader__container">
	        <div class="loader"></div>
	    </div>
    </div>
</div>